import { call, put, takeLatest } from "redux-saga/effects";
import {
  generateSolutionFail,
  generateSolutionSuccess,
  generateSolutionStart,
} from "../reducer";
import { postSolutionToAi } from "../../../services/generate";
import { networkErrorHandler } from "../../../utils/errorHandlers";

function* generateSolution({ payload }) {
  const response = yield call(postSolutionToAi, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(generateSolutionSuccess(raw));
  } else {
    yield put(generateSolutionFail(message || raw?.error));
    networkErrorHandler(response.statusCode, message || raw?.error);
  }
}

export default function* onGenerateSolution() {
  yield takeLatest(generateSolutionStart, generateSolution);
}
